// extracted by mini-css-extract-plugin
export default {"root":"styles_root__8pBOj","dragging-over":"styles_dragging-over__2CurS","draggingOver":"styles_dragging-over__2CurS","color":"styles_color__RrmZc"};